import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Badge } from "@/components/ui/badge";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";

const FORMS = ["kyc", "release", "takedown"];

export default function CustomFields() {
  const [rows, setRows] = useState([]);
  const [f, setF] = useState({ form: "kyc", label: "", field_type: "text" });

  const load = () => api.get("/custom-fields").then((r) => setRows(r.data));
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!f.label) return toast.error("Field label required");
    await api.post("/custom-fields", { ...f, options: [], required: false });
    toast.success("Custom field added");
    setF({ ...f, label: "" });
    load();
  };
  const del = async (id) => { await api.delete(`/custom-fields/${id}`); load(); };

  return (
    <div className="space-y-6" data-testid="custom-fields-page">
      <div><h1 className="font-heading text-3xl font-bold tracking-tight">Custom Fields</h1><p className="mt-1 text-muted-foreground">Add extra input requirements to any form to keep things customisable.</p></div>
      <Card className="p-6">
        <div className="flex flex-wrap items-end gap-3">
          <div>
            <Label>Form / Page</Label>
            <Select value={f.form} onValueChange={(v) => setF({ ...f, form: v })}>
              <SelectTrigger className="mt-1 w-40" data-testid="cf-form"><SelectValue /></SelectTrigger>
              <SelectContent>{FORMS.map((x) => <SelectItem key={x} value={x}>{x.toUpperCase()}</SelectItem>)}</SelectContent>
            </Select>
          </div>
          <div className="flex-1 min-w-[200px]"><Label>Field Label</Label><Input value={f.label} onChange={(e) => setF({ ...f, label: e.target.value })} data-testid="cf-label" className="mt-1" /></div>
          <div>
            <Label>Type</Label>
            <Select value={f.field_type} onValueChange={(v) => setF({ ...f, field_type: v })}>
              <SelectTrigger className="mt-1 w-32" data-testid="cf-type"><SelectValue /></SelectTrigger>
              <SelectContent>{["text", "number", "select", "file"].map((x) => <SelectItem key={x} value={x}>{x}</SelectItem>)}</SelectContent>
            </Select>
          </div>
          <Button onClick={add} data-testid="cf-add-btn"><Plus className="mr-2 h-4 w-4" />Add Field</Button>
        </div>
      </Card>
      <Card className="overflow-x-auto">
        <Table>
          <TableHeader><TableRow><TableHead>Form</TableHead><TableHead>Label</TableHead><TableHead>Type</TableHead><TableHead className="text-right">Action</TableHead></TableRow></TableHeader>
          <TableBody>
            {rows.length === 0 && <TableRow><TableCell colSpan={4} className="py-10 text-center text-muted-foreground">No custom fields yet.</TableCell></TableRow>}
            {rows.map((c) => (
              <TableRow key={c.id} data-testid={`cf-row-${c.id}`}>
                <TableCell><Badge variant="outline">{c.form.toUpperCase()}</Badge></TableCell>
                <TableCell className="font-medium">{c.label}</TableCell>
                <TableCell>{c.field_type}</TableCell>
                <TableCell className="text-right"><Button variant="ghost" size="icon" onClick={() => del(c.id)} data-testid={`cf-del-${c.id}`}><Trash2 className="h-4 w-4 text-rose-400" /></Button></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>
    </div>
  );
}
